import React, { useState, useEffect } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import { Button, NativeSelect, Paper } from '@material-ui/core';
import api from '../../../../services/api';
import { useParams } from 'react-router-dom';
import '../../TargetReport/TableContent/index.css';
import { useMessageBox } from '../../../../context/MessageBox';
import excelIcon from '../../../../assets/images/excel48.png';
import pdfIcon from '../../../../assets/images/pdf.png';
import * as S from './formStyle';
import { toast } from 'react-toastify';
import AnchorsLogoOptions from './AnchorsLogoOptions'

function OperationsMiddle({
  setTableData,
  setHeaderData,
  setTotalTableColumn,
  setTotalTableDataRow,
  setIsLoading,
  isLoading,
  anchors,
  handleSelectAnchor,
  selectedAnchor,
  triggerUpdateAnchor,
  setTriggerUpdateAnchor
}) {
  const classes = S.useStyles();
  const [mainDate, setMainDate] = useState(new Date());
  const [triggerUpdate, setTriggerUpdate] = useState(true);
  const [report, setReport] = useState();
  const screenParams = {
    title: 'Contas a Pagar',
    apiTable: 'Relatorios/Relatorio006ContasAPagar',
    apiDownload: 'Relatorios/Relatorio006ContasAPagarDownloadExcel',
    apiDownloadExcel: 'Relatorios/Relatorio006ContasAPagarDownloadExcel',
    dateFormat: 'MM/yyyy',
  };

  const { setMessageData } = useMessageBox();

  useEffect(async () => {
    if (mainDate && (triggerUpdate || triggerUpdateAnchor) && selectedAnchor) {
      await getInfoForForm();
    }
  }, [mainDate, selectedAnchor]);

  const getInfoForForm = async () => {
    const model = {
      mes: new Date(mainDate).getMonth() + 1,
      ano: new Date(mainDate).getFullYear(),
      ancoraId: selectedAnchor.ancoraId ? selectedAnchor.ancoraId : 0,
      plataformaId: selectedAnchor.plataformaId ? selectedAnchor.plataformaId : 0,
    };
    setReport(model);
    setIsLoading(true);

    try {
      const relatorio = await api.post(screenParams.apiTable, model);

      if (relatorio?.data?.complemento?.mensagensBox?.length > 0) {
        setMessageData(relatorio?.data?.complemento?.mensagensBox);
      }

      // Resetar a data do calendaraio sem atualizar o relatório
      if (relatorio?.data?.resposta?.dataPagamento) {
        setTriggerUpdate(false);
        setTriggerUpdateAnchor(false);
        setMainDate(new Date(relatorio?.data?.resposta?.dataPagamento));
      }

      if (relatorio.data.status !== 'Sucesso') {
        if (relatorio.data.resposta) {
          if (relatorio.data.resposta.length > 0) {
            relatorio.data.resposta.forEach((element) => {
              toast.error(element.message);
            });
          }
        }
      } else {
        setHeaderData(relatorio.data.resposta);
        setTableData(relatorio.data.resposta.itens);
        setTotalTableColumn(relatorio.data.resposta.totalizadorColuna);
        setTotalTableDataRow(relatorio.data.resposta.totalizadorLinha);
        // setTotalTableData(relatorio.data.resposta.totalGeral);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const exportTable = async (pdf) => {
    if (!report || pdf) return;
    setIsLoading(true);

    try {
      const url = pdf ? screenParams.apiDownload : screenParams.apiDownloadExcel;
      const relatorio = await api.post(url, report);

      if (relatorio?.data?.complemento?.mensagensBox?.length > 0) {
        setMessageData(relatorio?.data?.complemento?.mensagensBox);
      }

      if (relatorio.data.status !== 'Sucesso') {
        if (relatorio.data.resposta) {
          if (relatorio.data.resposta.length > 0) {
            relatorio.data.resposta.forEach((element) => {
              toast.error(element.message);
            });
          }
        }
        return;
      }

      const a = document.createElement('a');
      a.href =
        'data:' +
        relatorio.data.resposta.contentType +
        ';base64,' +
        relatorio.data.resposta.fileContents;
      a.download = relatorio.data.resposta.fileDownloadName;
      a.click();
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const initialize = async () => {
      setIsLoading(true);
      setIsLoading(false);
    };
    initialize();
  }, []);

  return (
    <>
      <div style={{ height: '100%' }}>
        <div className="new-body-schedule"
          style={{ justifyContent: 'space-between', display: 'flex', marginTop: '20px', alignItems: 'center' }}
        >
          <div style={{ minWidth: '20%' }}>
            <AnchorsLogoOptions
              anchors={anchors}
              handleSelectAnchor={handleSelectAnchor}
              selectedAnchor={selectedAnchor}
            />
          </div>
          <div className="schedule-input"
            style={{ display: 'flex', marginTop: '8px', alignItems: 'center',  flexDirection: 'column' }}
          >
            <span className={classes.label}>Mês de Referência: </span>
            <div style={{ display: "flex", alignItems: 'center' }}>
              <Button
                style={{ minWidth: '20px', width: '20px', height: '23px', paddingLeft: '20px' }}
                onClick={() => {
                  const newDate = new Date(mainDate);
                  setMainDate(newDate.setMonth(newDate.getMonth() - 1))
                  setTriggerUpdate(true);
                }}
              >
                🢀
              </Button>

              <div style={{ padding: '0px 5px', maxWidth: '150px', height: '23px' }}>
                <DatePicker
                  selected={mainDate}
                  onChange={(date) => {
                    setMainDate(date);
                    setTriggerUpdate(true);
                  }}
                  dateFormat={screenParams.dateFormat}
                  locale="ptBR"
                />
              </div>

              <Button
                style={{ minWidth: '20px', width: '20px', height: '23px' }}
                onClick={() => {
                  const newDate = new Date(mainDate);
                  setMainDate(newDate.setMonth(newDate.getMonth() + 1))
                  setTriggerUpdate(true);
                }}
              >
                🢂
              </Button>
            </div>
          </div>
          <div>
            <img
              src={excelIcon}
              onClick={() => {
                exportTable(false);
              }}
              style={{ cursor: 'pointer', marginRight: '8px' }}
            ></img>
            {/* <img src={pdfIcon} onClick={() => { exportTable(true) }} style={{ cursor: 'default', marginBottom: '4px' }} width="40"></img> */}
          </div>
        </div>
      </div>
    </>
  );
}

export default OperationsMiddle;
